import { render } from "./change-password-form.vue?vue&type=template&id=7bb9c306"
import script from "./change-password-form.vue?vue&type=script&lang=js"
export * from "./change-password-form.vue?vue&type=script&lang=js"

import "./change-password-form.vue?vue&type=style&index=0&id=7bb9c306&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__